module.exports = __webpack_public_path__ + "static/Cloudflare-62493bf64fd0ef6b42876bce7bb62adf.jpg";